module.exports = __webpack_public_path__ + "img/default_logo.ce8a4bc1.png";